"use client"

import Link from "next/link"

import { useAnalyticsContext } from "@/components/analytics-provider"
import { Button } from "@/components/ui/button"
import { Translate } from "@/components/ui/translate"
import { useLowercaseTranslation } from "@/hooks/use-lowercase-translation"
import { ComponentProps } from "react"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type ClassicRegistrationCardProps = {
  redirectTo: ComponentProps<typeof Link>["href"]
}

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/
const ClassicRegistrationCard = ({
  redirectTo,
}: ClassicRegistrationCardProps) => {
  const { sendData } = useAnalyticsContext()
  const t = useLowercaseTranslation()

  return (
    <div
      className={
        "bg-paper shadow-m relative flex w-full flex-1 flex-col overflow-hidden rounded-card border-1 border-(--classic-card-border) p-4"
      }
    >
      <h2 className="font-primary text-title-s mb-3 text-header-text font-bold">
        <Translate i18nKey={"SelectRegistrationPage.classicCard.title"} />
      </h2>
      <p className="text-paragraph-m mb-4 text-header-text">
        <Translate i18nKey={"SelectRegistrationPage.classicCard.subtitle"} />
      </p>
      <Button asChild className="ml-auto">
        <Link
          href={redirectTo}
          scroll={false}
          onClick={() =>
            sendData({
              event: "link_click",
              event_name: "reg_event",
              cta_label: t("SelectRegistrationPage.classicCard.cta"),
              click_detail: "registrati_veloce",
            })
          }
          data-testid="classic-signup-button"
        >
          <Translate i18nKey={"SelectRegistrationPage.classicCard.cta"} />
        </Link>
      </Button>
    </div>
  )
}

export { ClassicRegistrationCard }
